module.exports = __webpack_public_path__ + "static/img/fuweiguo_top.2be5fe3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/fuweiguo_top.png
// module id = Xzvv
// module chunks = 4